import { TenantType } from '../tenants/index.js';
export var FeatureFlag;
(function (FeatureFlag) {
    // MODULES
    FeatureFlag["TRIBUNAL"] = "TRIBUNAL";
    FeatureFlag["AISuggestions"] = "AI_SUGGESTIONS";
    FeatureFlag["ASSETS"] = "ASSETS";
    FeatureFlag["Sftp"] = "SFTP";
    // EXPERIMENTAL
    FeatureFlag["COSMO_V2"] = "COSMO_V2";
    FeatureFlag["LEDGER_CASE_VOUCHER_TABLE"] = "LEDGER_CASE_VOUCHER_TABLE";
    FeatureFlag["EconomyEngineV2"] = "ECONOMY_ENGINE_V2";
    // AGENCY GENERAL MANAGEMENT REPORT
    FeatureFlag["AGENCY_GENERAL_MANAGEMENT_REPORT"] = "AGENCY_GENERAL_MANAGEMENT_REPORT";
    FeatureFlag["E_INVOICE_INTERNATIONAL"] = "E_INVOICE_INTERNATIONAL";
    FeatureFlag["MobilePeopleBSMandate"] = "MOBILE_PEOPLE_BS_MANDATE";
    // Temporary kill-switch for the payer-choice (card or BS) MobilePeople link.
    // Remove the flag and keep payer-choice once it is verified in production.
    FeatureFlag["MobilePeopleBSLink"] = "MOBILE_PEOPLE_BS_LINK";
    // BESPOKE
    FeatureFlag["ApcoaBusinessCentral"] = "APCOA_BUSINESS_CENTRAL";
})(FeatureFlag || (FeatureFlag = {}));
export const FeatureFlagToMeta = {
    [FeatureFlag.TRIBUNAL]: {
        type: 'MODULE',
        name: 'Tribunal module',
        description: 'The tribunal module enables automatic handling of tribunal cases.',
    },
    [FeatureFlag.COSMO_V2]: {
        type: 'EXPERIMENTAL',
        name: 'Cosmo V2',
        description: 'The new and improved Cosmo module 🌐',
    },
    [FeatureFlag.LEDGER_CASE_VOUCHER_TABLE]: {
        type: 'EXPERIMENTAL',
        name: 'Case voucher statement with running balances',
        description: 'Lets case voucher tables be set up as a chronological statement with monthly interest, payment distribution and running balances.',
    },
    [FeatureFlag.EconomyEngineV2]: {
        type: 'EXPERIMENTAL',
        name: 'Economy engine v2',
        description: 'New cases calculate limitation per amount, so payments that do not interrupt limitation no longer leave paid interest to expire.',
    },
    [FeatureFlag.AISuggestions]: {
        type: 'MODULE',
        name: 'AI suggestions',
        description: 'Enables AI suggestions on interactions',
    },
    [FeatureFlag.AGENCY_GENERAL_MANAGEMENT_REPORT]: {
        type: 'EXPERIMENTAL',
        name: 'Agency General Management Report',
        description: 'New report for agencies that can be used by general management.',
    },
    [FeatureFlag.E_INVOICE_INTERNATIONAL]: {
        type: 'MODULE',
        name: 'E-invoice International',
        description: 'Enables sending of international e-invoices.',
    },
    [FeatureFlag.ASSETS]: {
        type: 'MODULE',
        name: 'Assets',
        description: 'Enables tracking of debtor assets and liens.',
    },
    [FeatureFlag.MobilePeopleBSMandate]: {
        type: 'MODULE',
        name: 'Betalingsservice mandate (MobilePeople)',
        description: 'Lets caseworkers create a Betalingsservice mandate directly from a payment plan for tenants using MobilePeople as PSP.',
    },
    [FeatureFlag.MobilePeopleBSLink]: {
        type: 'MODULE',
        name: 'Betalingsservice via payment link (MobilePeople)',
        description: 'Lets the debtor choose Betalingsservice on the MobilePeople recurring payment link instead of card only. Disable to fall back to card-only links.',
    },
    [FeatureFlag.Sftp]: {
        type: 'MODULE',
        name: 'SFTP',
        description: 'Enables SFTP servers for exchanging files with creditors and partners.',
    },
    [FeatureFlag.ApcoaBusinessCentral]: {
        type: 'BESPOKE',
        name: 'APCOA Business Central',
        description: 'Reads APCOA/EuroIncasso ERP data from Business Central (OAuth) instead of NAV (basic auth). Toggle per tenant when that tenant has been migrated.',
    },
};
const TenantTypeFeatureFlags = {
    [TenantType.Agency]: {
        [FeatureFlag.TRIBUNAL]: true,
        [FeatureFlag.COSMO_V2]: true,
    },
    [TenantType.AccountsReceivable]: {
        [FeatureFlag.COSMO_V2]: true,
    },
};
export const hasEnabled = (flag, tenant) => {
    const flags = {
        ...(tenant.type ? TenantTypeFeatureFlags[tenant.type] : {}),
        ...tenant.featureFlags,
    };
    return flags[flag] === true;
};
//# sourceMappingURL=index.js.map